export const FEATURE_TOGGLES = {
  /**
   * Add feature toggles that have to be stored from configuration response.
   *
   * NameUnderWantToStore: 'NameInConfigurationResponse',
   */
  IndividualTaxId: 'IndividualRestrictedFieldTaxId',
};
